export default __webpack_public_path__ + "static/media/tex-gyre-adventor-bold.444db04e.woff2";